import {useSelectContext} from 'components/customer/Product/Appliance/Select';
import {Appliance} from 'components/customer/Product/Appliance/entity/Appliance';
import {RANGEHOOD} from 'components/customer/Product/store/productApi';
import React, {useCallback, useMemo} from 'react';
import {components, NoticeProps} from 'react-select';
import styled from 'styled-components';

export const CustomNoOptions = (props: NoticeProps<Appliance, false>) => {
    const {type, showApplianceForm} = useSelectContext();

    const handleClick = useCallback(() => {
        if (showApplianceForm) {
            showApplianceForm();
        }
    }, [type, showApplianceForm]);

    const label = useMemo(() => {
        switch (type) {
            case RANGEHOOD:
                return 'rangehood';
            default:
                return 'appliance';
        }
    }, [type]);

    return (
        <>
            <components.NoOptionsMessage {...props}>
                No {label}s found
            </components.NoOptionsMessage>

            <Line />

            <Button onClick={handleClick}>Enter custom {label}</Button>
        </>
    );
};

const Line = styled.hr`
    margin: 0 20px 10px;
    background-color: gray;
`;

const Button = styled.label`
    text-align: center;
    cursor: pointer;
    display: block;
`;
